var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "youtube-channels" } },
    [
      _c("AppBreadCrumb", {
        attrs: { paths: [{ title: "YouTube Comments" }], select: true },
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "d-flex right-page",
          staticStyle: { "background-color": "#ffffff" },
        },
        [
          _c(
            "div",
            { staticClass: "ml-3 mt-3", staticStyle: { flex: "0 0 100%" } },
            [
              _c("div", { staticClass: "big-title" }, [
                _vm._v(_vm._s(_vm.$t("youtubeChannel.youtubeChannels"))),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "channels" },
                [
                  _c(
                    "div",
                    {
                      staticClass: "story channel-add",
                      on: { click: _vm.createChannel },
                    },
                    [
                      _c("a-icon", {
                        staticStyle: { "font-size": "30px" },
                        attrs: { type: "plus-circle", theme: "filled" },
                      }),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          staticClass: "text-large font-weight-bolder mt-2",
                          staticStyle: {
                            "font-size": "20px",
                            "letter-spacing": "2px",
                          },
                        },
                        [
                          _vm._v(
                            "\n                        " +
                              _vm._s(_vm.$t("whatsappChannel.addChannel")) +
                              "\n                    "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm._l(_vm.channels, function (channel, index) {
                    return _c(
                      "div",
                      {
                        key: index,
                        staticClass: "channel-item",
                        class: { disabled: !_vm.isChannelAccessible(channel) },
                        on: {
                          click: function () {
                            return (
                              _vm.isChannelAccessible(channel) &&
                              _vm.editChannel(channel)
                            )
                          },
                        },
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "icon-container" },
                          [_c("YouTubeIcon")],
                          1
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "name-container" }, [
                          _c("span", { staticClass: "name" }, [
                            _vm._v(_vm._s(channel.name.toUpperCase())),
                          ]),
                          _vm._v(" "),
                          channel.payload && channel.payload.youtubeChannelTitle
                            ? _c("span", { staticClass: "channel-title" }, [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(
                                      channel.payload.youtubeChannelTitle
                                    ) +
                                    "\n                        "
                                ),
                              ])
                            : _vm._e(),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "options" },
                          [
                            _c(
                              "a-dropdown",
                              {
                                attrs: {
                                  trigger: ["click"],
                                  placement: "bottomRight",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "overlay",
                                      fn: function () {
                                        return [
                                          _c(
                                            "a-menu",
                                            [
                                              _c(
                                                "a-menu-item",
                                                {
                                                  staticStyle: {
                                                    display: "flex",
                                                    gap: "5px",
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.copyChannelId(
                                                        channel._id
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "i",
                                                    {
                                                      staticClass:
                                                        "material-icons",
                                                    },
                                                    [_vm._v("content_copy")]
                                                  ),
                                                  _vm._v(" "),
                                                  _c("span", [
                                                    _vm._v(
                                                      "Channel ID Kopyala"
                                                    ),
                                                  ]),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c("a-menu-item", [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "icon-container",
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.showDeleteConfirmation(
                                                          channel._id
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "md-icon",
                                                      {
                                                        staticStyle: {
                                                          "margin-right":
                                                            "10px",
                                                        },
                                                      },
                                                      [_vm._v("delete")]
                                                    ),
                                                    _vm._v(" "),
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "chatbotv2.delete"
                                                          )
                                                        )
                                                      ),
                                                    ]),
                                                  ],
                                                  1
                                                ),
                                              ]),
                                            ],
                                            1
                                          ),
                                        ]
                                      },
                                      proxy: true,
                                    },
                                  ],
                                  null,
                                  true
                                ),
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "icon-container ant-dropdown-link",
                                    on: {
                                      click: function (e) {
                                        return e.stopPropagation()
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "span",
                                      { staticClass: "material-icons" },
                                      [_vm._v("more_horiz")]
                                    ),
                                  ]
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ]
                    )
                  }),
                ],
                2
              ),
            ]
          ),
        ]
      ),
      _vm._v(" "),
      _vm.showCreateForm
        ? _c(
            "Modal2",
            {
              attrs: {
                title: _vm.$t("youtubeChannel.connectToYouTube"),
                description: _vm.$t("youtubeChannel.connectToYouTube"),
                "class-name": "new-youtube-channel",
                showFooter: false,
              },
              on: {
                cancel: function ($event) {
                  _vm.showCreateForm = false
                },
              },
            },
            [
              _c("CreateYouTubeChannel", {
                on: {
                  cancel: function ($event) {
                    _vm.showCreateForm = false
                  },
                  ok: _vm.onChannelCreated,
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "a-modal",
        {
          attrs: {
            visible: _vm.deleteModal,
            icon: "exclamation-circle",
            title: _vm.$t("youtubeChannel.youtubeIntegration"),
          },
          on: {
            cancel: function ($event) {
              _vm.deleteModal = false
            },
          },
          scopedSlots: _vm._u([
            {
              key: "footer",
              fn: function () {
                return [
                  _c(
                    "a-button",
                    {
                      key: "back",
                      on: {
                        click: function ($event) {
                          _vm.deleteModal = false
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.$t("chatbotv2.dismiss")) +
                          "\n            "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "a-button",
                    {
                      key: "submit",
                      attrs: { type: "danger" },
                      on: { click: _vm.deleteYoutubeChannel },
                    },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.$t("chatbotv2.delete")) +
                          "\n            "
                      ),
                    ]
                  ),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [
          _c("p", [
            _vm._v(_vm._s(_vm.$t("youtubeChannel.deleteYoutubeChannelInfo"))),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }